import { useContext } from 'react';
import { UNSAFE_RouteContext } from 'react-router-dom';

export default function useRouterContext() {
    const context = useContext(UNSAFE_RouteContext);

    if (!context) {
        throw new Error(
            'useRouterContext must be used within a Router context. ' +
            'Ensure your app is wrapped in <RouterProvider> at the top level.'
        );
    }

    return context;
}
